export default {
  D1: 'D1',
  D2: 'D2',
  D4: 'D4',
  D7: 'D7',
  D14: 'D14',
  D28: 'D28',
  Steam: 'Steam',
  'M Science': 'M Science',
  Famitsu: 'Famitsu',
  NPD: 'NPD',
  // Newzoo: 'DataBrain',
  Newzoo: 'No-Update',
  VGI: 'VGI',
};
